exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".-WYmZJS0DfMHzCB6hu_xq{-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%}html[dir=ltr] .-WYmZJS0DfMHzCB6hu_xq,html[dir=rtl] .-WYmZJS0DfMHzCB6hu_xq{padding-right:12px;padding-left:12px}._3Oi1-y3Tr4AnX20-gIZSAt,.OQsPvyhAxhC6bhOM1FvdL,._2wkZ4lTeTCx89ikqjM68T6{width:100%}", ""]);
// Exports
exports.locals = {
	"emptyStateContainer": "-WYmZJS0DfMHzCB6hu_xq",
	"container": "_3Oi1-y3Tr4AnX20-gIZSAt",
	"detailsMessage": "OQsPvyhAxhC6bhOM1FvdL",
	"mainMessage": "_2wkZ4lTeTCx89ikqjM68T6"
};